import { useState } from "react";
import { App, Button, Image, Input, Space, Upload } from "antd";

import { uploadsApi } from "../api/resources";

/**
 * 双模 image input:
 *   - 上传到 R2（默认）
 *   - 直接粘贴 URL（兜底，避免没绑 R2 时不能用）
 *
 * value/onChange 透出 URL string，行为和 antd Input 一致，可以放进 Form.Item。
 */
export function ImageUpload({
  value,
  onChange,
  folder,
  width = 80,
  height = 80,
}: {
  value?: string;
  onChange?: (url: string) => void;
  folder?: string;
  width?: number;
  height?: number;
}) {
  const { message } = App.useApp();
  const [uploading, setUploading] = useState(false);

  return (
    <Space direction="vertical" style={{ width: "100%" }}>
      <Space>
        {value ? (
          <Image
            src={value}
            width={width}
            height={height}
            style={{ borderRadius: 6, objectFit: "contain", background: "#fafafa" }}
            fallback="data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' width='80' height='80'%3E%3Crect width='100%' height='100%' fill='%23f0f1f5'/%3E%3C/svg%3E"
          />
        ) : (
          <div
            style={{
              width,
              height,
              background: "#f0f1f5",
              borderRadius: 6,
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
              color: "#909399",
              fontSize: 12,
            }}
          >
            预览
          </div>
        )}
        <Upload
          accept="image/*"
          showUploadList={false}
          beforeUpload={async (file) => {
            setUploading(true);
            try {
              const r = await uploadsApi.upload(file as File, folder);
              onChange?.(r.url);
              message.success("上传成功");
            } catch (err) {
              message.error(err instanceof Error ? err.message : "上传失败");
            } finally {
              setUploading(false);
            }
            return false;
          }}
        >
          <Button loading={uploading} size="small">
            上传图片
          </Button>
        </Upload>
        {value && (
          <Button size="small" type="link" onClick={() => onChange?.("")}>
            清除
          </Button>
        )}
      </Space>
      <Input
        size="small"
        placeholder="或粘贴 URL"
        value={value ?? ""}
        onChange={(e) => onChange?.(e.target.value)}
      />
    </Space>
  );
}
